import { autoinject } from 'aurelia-framework';
import { DialogController } from "aurelia-dialog";
import { WebApiService } from "../../services/web-api-service";
import 'jquery';
import 'notify';
import { AppMessageService } from '../../services/app-message-service';
import { Carrier } from '../../models/carrier';

@autoinject
export class SearchCarrierDialog {
    constructor(protected controller: DialogController, private api: WebApiService,
        private msg: AppMessageService) {
        this.msg.containerId = "search-carrier-dialog";
    }

    keyword: string;
    selectedCarrier: Carrier;
    carriers: Carrier[] = [];

    activate(params) {
    }

    search() {
        //save comments immediately; low impact because they are append-only
        this.msg.clearNonPersistentMessages();
        var params = {
            keyword: this.keyword
        };
        this.api.post("Carriers", "GlobalSearch?keyword=" + this.keyword)
            .then(result => {
                let carriers = JSON.parse(result.response);


                ////filter out those records that don't match SCAC or carrier id
                //const keyword = this.keyword.toLowerCase();
                //carriers = carriers.filter((o: Carrier) => {
                //    return keyword == o.id.toString().toLowerCase() || keyword == (o.scacCode || "").toLowerCase() || ((o.dedicatedScacCodes || "").toLowerCase().indexOf(keyword) > -1);
                //});

                this.carriers = carriers;

                //if (carriers) {
                //    if (carriers.length == 1) {
                //        const carrier = carriers[0];
                //        this.controller.ok(carrier);
                //    } else if (carriers.length == 0) {
                //        this.msg.addErrorMessage(`No matching carriers found.`);
                //    } else {
                //        this.msg.addErrorMessage(`${carriers.length} matching carriers found. Please narrow your search`);
                //    }
                //}
            }, e => {
                this.msg.addErrorMessage(e || "Error occurred.");
            });
    }


    selectCarrier() {
        this.controller.ok(this.selectedCarrier);
    }


}